/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Just_NowInputs */

const vi_notif_just_now = /** @type {(inputs: Notif_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vừa xong`)
};

/**

* @param {Notif_Just_NowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_just_now = /** @type {((inputs?: Notif_Just_NowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Just_NowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_just_now(inputs)
});